<template>
    <div style="background-color: rgb(242, 247, 250);">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="error-content">
                        <div class="logo-template-error pb-5 mx-4 mb-5">
                            <img src="/assets/backend/img/logo.svg" class="img-fluid" alt="logo">
                        </div>
                        <div class="error-card text-center p-5 m-4">
                            <h2>{{ titles[status] }}</h2>
                            <div class="error-details py-3">{{ messages[status] }}</div>

                            <div class="error-actions pt-3">
                                <a href="/take-me-home" class="btn btn-primary btn-lg bg-primary">{{ status == '503' ? $t('Try again') : $t('Take me home') }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            status: this.$route.params.status,
            titles: {
                '403': this.$t('403 Access forbidden'),
                '404': this.$t('404 Not found'),
                '419': this.$t('419 Page Expired'),
                '500': this.$t('500 Server error'),
                '503': this.$t('503 Under maintenance')
            },
            messages: {
                '403': this.$t('You are trying to access a page for which you don\'t have privileges.'),
                '404': this.$t('The link is broken or the page has moved, we couldn\'t complete your request'),
                '419': this.$t('It looks like the page you are trying to access has expired. Please make sure you are logged in the application and try again.'),
                '500': this.$t('We are very sorry, but were unable to complete your request. We took a note about this error and we will provide a fix as soon as possible.'),
                '503': this.$t('Sorry for the inconvenience but we\'re performing some maintenance at the moment and we will be back online shortly. Thanks for your patience.')
            }
        }
    },
    beforeMount() {
        if (!Object.keys(this.titles).includes(this.status)) {
            this.status = 404;

            this.$router.replace('/error/404');
        }
    }
}
</script>
